export default __webpack_public_path__ + "static/media/pest2.3a718d89.jpeg";